import type { SVGProps } from "react";
import { FileText } from "lucide-react";

export function TypeOfLossIcon(props: SVGProps<SVGSVGElement>) {
  return <FileText color="currentColor" {...props} className={`w-5 h-5 ${props.className ?? ""}`} />;
}
